$(function(){

	if ($('body.insights').length) {

		const itemTemplate = ({
			url,
			title,
			category
		}) => `
			<a href="${url}" class="col-span-12 md:col-span-6 lg:col-span-4 p-16 insight-item bg-green-dark text-mint font-medium hover:text-green-dark hover:bg-lime transition">
				<span class="label mb-8 inline-block">${category}</span>
				<h3 class="h2 capitalize !mb-20">${title}</h3>
				<span class="read-more flex items-center gap-8">READ MORE
					<svg id="arrow-right" xmlns="http://www.w3.org/2000/svg" width="15.097" height="12" viewBox="0 0 15.097 12">
						<path id="Path_5304" data-name="Path 5304" d="M11.689,5.822a.581.581,0,0,1,.821,0l5.41,5.419a.581.581,0,0,1,0,.82l-5.41,5.419a.581.581,0,0,1-.822-.82l4.42-4.428-12.534.009a.581.581,0,1,1,0-1.161l12.537-.009L11.688,6.643A.581.581,0,0,1,11.689,5.822Z" transform="translate(-2.992 -5.653)" fill="currentColor" fill-rule="evenodd"/>
					</svg>
				</span>
			</a>
		`;

		$('.next-page').on('click', function(e) {
			e.preventDefault();

			let _this = this;
			let currentPage = $(this).data('page');

			$.getJSON("/insights.json?page=" + (currentPage + 1), function(data) {

				$('.item-container').append(data.data.map(itemTemplate).join(''));

				$(_this).data('page', data.meta.pagination.current_page);

				if (data.meta.pagination.total_pages === data.meta.pagination.current_page) {
					$(_this).hide();
				}
			});
		});
	}
});
